import React, { FC } from 'react';
import { GaugesEnum } from 'data/types/gauges.types';
import { ReactComponent as ActiveTickets } from 'assets/images/dashbarIcons/activeTickets.svg';
import { ReactComponent as OverdueTickets } from 'assets/images/dashbarIcons/overdueTickets.svg';
import { ReactComponent as OverdueTasks } from 'assets/images/dashbarIcons/overdueTasks.svg';
import { ReactComponent as SlaHealth } from 'assets/images/dashbarIcons/slaHealth.svg';
import { ReactComponent as AvgUrgency } from 'assets/images/dashbarIcons/avgUrgency.svg';
import { ReactComponent as CustomerHealth } from 'assets/images/dashbarIcons/customerHealth.svg';

/* The collapsed dashbar's icons, taken from the ZEST-757 design rather than the
   icomoon set. Keyed by gauge type; OPEN_TICKETS carries the merged ACTIVE
   TICKETS tile. Anything unmapped renders nothing, which is what the gauges
   without a design icon did before. */
const gaugeIcons: Partial<
  Record<GaugesEnum, FC<React.SVGProps<SVGSVGElement>>>
> = {
  [GaugesEnum.OPEN_TICKETS]: ActiveTickets,
  [GaugesEnum.NEW_TICKETS]: ActiveTickets,
  [GaugesEnum.OVERDUE_TICKETS]: OverdueTickets,
  [GaugesEnum.OVERDUE_TASKS]: OverdueTasks,
  [GaugesEnum.SLA_CLOSE_TO_FAIL]: SlaHealth,
  [GaugesEnum.AVG_URGENCY]: AvgUrgency,
  [GaugesEnum.CUSTOMERS_NEEDING_INTERACTION]: CustomerHealth,
};

type TGaugeIconProps = {
  type: GaugesEnum;
  size?: number;
};

const GaugeIcon: FC<TGaugeIconProps> = ({ type, size = 20 }) => {
  const Icon = gaugeIcons[type];
  if (!Icon) return null;
  return (
    <Icon
      className="gauge-icon"
      width={size}
      height={size}
      data-testid={`gauge-icon-${type}`}
      aria-hidden
    />
  );
};

export default GaugeIcon;
